const textMk = (...txts) => txts.filter(d => d).join(' ')
export default textMk